import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const OnboardingOTP = ({ pan, onVerified }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [maskedMobile, setMaskedMobile] = useState(""); // ✅ store mobile from backend

  // ✅ Ref to prevent sending OTP twice
  const otpSentRef = useRef(false);

  // Send OTP on mount (once per PAN)
  useEffect(() => {
    if (!pan || otpSentRef.current) return; // don't send again

    const sendOtp = async () => {
      otpSentRef.current = true; // lock sending
      setSending(true);
      setError("");
      try {
        const res = await axios.post("/api/send-otp", { pan });
        if (res.data.success) {
          setMaskedMobile(res.data.maskedMobile || "your mobile");
        } else {
          setError(res.data.error || "Failed to send OTP");
          otpSentRef.current = false; // unlock if failed
        }
      } catch (err) {
        console.error("OTP send error:", err);
        setError("Failed to send OTP");
        otpSentRef.current = false; // unlock if failed
      } finally {
        setSending(false);
      }
    };

    sendOtp();
  }, [pan]);

  const verifyOtp = async () => {
    const otpValue = otp.trim();
    if (otpValue.length !== 6) {
      setError("Enter 6 digit OTP");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await axios.post("/api/verify-otp", { pan, otp: otpValue });
      if (res.data.success) {
        onVerified(); // ✅ go to next step
      } else {
        setError(res.data.error || "Invalid OTP");
      }
    } catch (err) {
      console.error("OTP verification error:", err);
      setError("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h3>Verify OTP</h3>
      <p>OTP sent to {maskedMobile || "your mobile"}</p>
      {sending && <p>Sending OTP...</p>}

      <input
        placeholder="Enter OTP"
        value={otp}
        maxLength={6}
        onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
      />

      <button onClick={verifyOtp} disabled={loading || sending}>
        {loading ? "Verifying..." : "Verify OTP"}
      </button>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default OnboardingOTP;